import { render, staticRenderFns } from "./TabelaAbaRequisicoes.vue?vue&type=template&id=df0b0366&"
import script from "./TabelaAbaRequisicoes.vue?vue&type=script&lang=js&"
export * from "./TabelaAbaRequisicoes.vue?vue&type=script&lang=js&"
import style0 from "./TabelaAbaRequisicoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports